import React from 'react';
import { Result, Button, Typography } from 'antd';

const { Paragraph, Text } = Typography;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '50px', background: '#0f1419', minHeight: '100vh' }}>
          <Result
            status="error"
            title="畫面渲染發生錯誤 (React Render Crash)"
            subTitle="系統在顯示此畫面時遇到未預期的錯誤，這通常是因為資料格式不符導致的。"
            extra={[
              <Button type="primary" key="console" onClick={() => window.location.reload()}>
                重新整理頁面
              </Button>
            ]}
          >
            <div className="desc" style={{ background: '#1a1f2e', padding: '24px', borderRadius: '8px', textAlign: 'left' }}>
              <Paragraph>
                <Text strong style={{ fontSize: 16, color: '#ff4d4f' }}>
                  錯誤訊息:
                </Text>
                <br />
                <Text type="secondary" style={{ fontFamily: 'monospace' }}>{this.state.error && this.state.error.toString()}</Text>
              </Paragraph>
              <Paragraph>
                <Text strong style={{ fontSize: 16, color: '#ff4d4f' }}>
                  Stack Trace:
                </Text>
                <br />
                <Text type="secondary" style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', fontSize: '12px' }}>
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </Text>
              </Paragraph>
            </div>
          </Result>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
